<script>
import Cookies from 'js-cookie'
import 'polyfill-array-includes'
import systemConst from '@SYSTEM_CONSTANTS'

export default {
    data () {
        return {
            blik: process.env.VUE_APP_SYSTEM + '_wplata_blik',
            card: process.env.VUE_APP_SYSTEM + '_wplata_karta',
            druk: process.env.VUE_APP_SYSTEM + '_wplata_tradycyjna',
            wipDruk: process.env.VUE_APP_SYSTEM + '_wplata_wip_tradycyjna',
            payment: process.env.VUE_APP_SYSTEM + '_wplata'
        }
    },
    created () {
        const product = this.getProductFromCookie()
        
        if (product !== null) {
            this.pushTransaction(product)
        }
    },
    methods: {
        getProductFromCookie () {
            const cookie = Cookies.get('wplatomat_dataLayer')

            if (undefined === cookie) {
                return null
            }

            const cookieValSplitted = cookie.split('|')

            if (cookieValSplitted.length !== 3) {
                return null
            }

            return {
                sku: parseInt(cookieValSplitted[1]),
                name: cookieValSplitted[2],
                category: systemConst.SYSTEM_SHORTCUT,
                price: parseFloat(cookieValSplitted[0]),
                quantity: 1
            }
        },
        pushTransaction (product) {
            if (product.sku < systemConst.KEY2_SKU || product.sku > systemConst.KEY5_SKU) {
                return
            } else if (![ this.payment, this.wipDruk, this.druk, this.card, this.blik ].includes(product.name)) {
                return
            }
            const transaction = {
                transactionId: (new Date()).getTime(),
                transactionAffiliation: 'Stowarzyszenie Wiosna',
                transactionTotal: product.price,
                transactionTax: 0,
                transactionShipping: 0,
                transactionProducts: [product]
            }

            dataLayer.push(transaction)

            this.$gtm.trackEvent({
                event: 'payment_form.transaction_data_pushed'
            })
            Cookies.remove('wplatomat_dataLayer')
        }
    }
}
</script>
